<script setup lang="ts">
import CommonInput from "~/components/Common/Inputs/CommonInput.vue";

const props = defineProps(["modelValue", "error", "label", "disabled", "prefixe"]);
const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <div>
    <h5 class="body_regular text-secondary-color mb-2">{{ label }}</h5>
    <div class="flex gap-2" :class="!error ? 'h-10' : 'h-[68px]'">
      <input
        v-if="prefixe"
        type="text"
        class="input__default !leading-[4px] max-h-[40px] body_regular min-w-[240px]"
        placeholder="nom prénom du participant"
        :value="prefixe"
        disabled
      />
      <div class="w-full flex flex-col">
        <CommonInput
          v-model="value"
          style="text-align: start"
          placeholder="Sujet du mail"
          :error="!!error"
          :disabled="disabled"
          class="max-h-[40px] w-full"
        />
        <span v-if="error" class="mt-1 body_regular text-primary-red-color">{{ error["$message"] }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
